export default {"src":"/_next/static/media/machine.2087822b.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};